export enum PageSubscriptionsActionTypes {
  FETCHING = 'page-subscriptions/FETCHING',
  RECEIVED = 'page-subscriptions/RECEIVED',
  ERROR = 'page-subscriptions/ERROR',

  COUNT_SUBS_LOADING = 'page-subscriptions/COUNT_SUBS_LOADING',
  COUNT_SUBS_SUCCESS = 'page-subscriptions/COUNT_SUBS_SUCCESS',
  COUNT_SUBS_ERROR = 'page-subscriptions/COUNT_SUBS_ERROR',
}
